import React, { useState, useEffect } from 'react';
import api from '@http/api';
import TableNoPagination from '../../../Tables/TableColapseNoPaginationContribIR';

import { Grid, IconButton } from '@material-ui/core';
import { FormatDate } from '@utils/formats';
import InvisibleContent from '@src/components/Shared/InvisibleContent';
import Button from '@components/Shared/Buttons/Button';
import { ReportGmailerrorred } from '@mui/icons-material/';
import Modal from '@src/components/Shared/Modal/ModalPure';
import ModalPendencia from '../ModalPendencia';


import { Form, Select as SelectAntd, Spin, Upload, Input } from 'antd';

import ButtonComponent from '@components/Shared/Buttons/Button';
import { FindInPageOutlined, CheckCircleOutlined, FontDownloadOutlined, TuneOutlined} from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import { FileDownloadOutlined, FileUploadOutlined, CloseRounded, SearchOutlined } from '@mui/icons-material/';
import { addDays } from 'date-fns';

import Services, {IGetAllProjetoByPerfil, ILista, IDocumento, IAno} from './services';

interface IProps {
  idPerfil: number;
  functionReload?: Function;}

const columnsLabel = {
  dataInserida: 'Data inserida',
  documentoImposto: 'Documento',
  ano: 'Ano',
  linkS3: 'Arquivo',
};

const DATA = addDays(new Date(), 0).toISOString().split('T')[0];

const IR: React.FC<IProps> = ({
  idPerfil,
}) => {
  const [loading, setLoading] = useState(false);
  const [loadingImporte, setLoadingImporte] = useState(false);

  const [data, setData] = useState<ILista[]>([]);
  const [projeto, setProjeto] = useState<IGetAllProjetoByPerfil[]>([]);
  const [formRef] = Form.useForm();
  const { enqueueSnackbar } = useSnackbar();
  const [formaContribuicao, setFormaContribuicao] = useState('Doação anual');
  const [openFiltro, setOpenFiltro] = useState(false);
  const [openImporte, setOpenImporte] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [upload, setUpload] = useState<any>();
  const [pendenciaDoc, setPendenciaDoc] = useState<any>();
  const [openModalPendencia, setOpenModalPendencia] = useState(false);
  const [documentoDoacaoAnual, setDocumentoDoacaoAnual] = useState<IDocumento[]>([
    { id: 1, descricao: 'Carta' },
    { id: 2, descricao: 'Comprovante de pagamento' },
    { id: 3, descricao: 'Recibo'},
  ]);

  const [ano, setAno] = useState<IAno[]>([
    { id: 2026, descricao: '2026'},
    { id: 2025, descricao: '2025'},
    { id: 2024, descricao: '2024'},
    { id: 2023, descricao: '2023' },
    { id: 2022, descricao: '2022' },
    { id: 2021, descricao: '2021'},
    { id: 2020, descricao: '2020'},
    { id: 2019, descricao: '2019'},
    { id: 2018, descricao: '2018'},
  ]);

  async function loadDocumentosPendentesIR() {
    setLoading(true);
     try {
      const response = await api.get(`/api/DocumentacaoProjetoIr/GetPendentesByPerfil/${idPerfil}`)

      setPendenciaDoc(response.data.temPendencias);
      setLoading(false);

    } finally {
      setLoading(false);
    }
  }

  async function loadGetAllProjetosByPerfil() {
    setLoading(true);

    const service = new Services();
    const { error, response } = await service.loadGetAllProjetosByPerfil(idPerfil);
    setProjeto(response);

    setLoading(false);
  }

  async function loadData() {
    setLoading(true);
    try {
      const response = await api.get(`api/ContribuicoesDarf/ListagemPerfil?perfilId=${idPerfil}&&formaContribuicao=${formaContribuicao}`)
      const items = response.data.documentos || [];
      if (items.length > 0) {

        const itemData: ILista[] = items.map((item: ILista) => ({
          dataInserida: FormatDate(item.dataInserida),
          //tipoContribuicao: item.tipoContribuicao,
          documentoImposto: item.documentoImposto,
          ano: item.ano,
          fundoNome: item.fundoNome,
          projetoNome: item.projetoNome,
          linkS3: item.linkS3,
        }));

        setData(itemData);
        setLoading(false);
      } else {
        setData([]);
        enqueueSnackbar('Nenhuma doação encontrada para esta página.', {
          variant: 'info',
        });
      }
    } catch (error) {
      console.error('Erro ao carregar doações:', error);
      setData([]);

    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadData();
    loadDocumentosPendentesIR();
    loadGetAllProjetosByPerfil();
  }, [idPerfil]);


  async function loadDataFiltros() {

    const documento = formRef.getFieldValue('tipoDocumento');
    const ano = formRef.getFieldValue('ano');
    const projeto = formRef.getFieldValue('projeto');

    setLoading(true);

    if (projeto !== undefined && documento !== undefined && ano !== undefined){
      try {
        const response = await api.get(`api/ContribuicoesDarf/ListagemPerfil?perfilId=${idPerfil}&&formaContribuicao=${formaContribuicao}&&documentoImposto=${documento}&&projetoId=${projeto}&&ano=${ano}`)

        const items = response.data.documentos || [];
        if (items.length > 0) {

          const itemData = items.map((item: ILista) => ({
            dataInserida: FormatDate(item.dataInserida),
            //tipoContribuicao: item.tipoContribuicao,
            documentoImposto: item.documentoImposto,
            linkS3: item.linkS3,
            ano: item.ano,
            fundoNome: item.fundoNome,
            projetoNome: item.projetoNome,
          }));

          setData(itemData);
          setLoading(false);
        } else {
          setData([]);
          enqueueSnackbar('Nenhuma doação encontrada para esta página.', {
            variant: 'info',
          });
        }
      } catch (error) {
        console.error('Erro ao carregar doações:', error);
        setData([]);


      } finally {
        setLoading(false);
      }
    } else if (projeto !== undefined  && documento !== undefined && ano === undefined){
      try {
        const response = await api.get(`api/ContribuicoesDarf/ListagemPerfil?perfilId=${idPerfil}&&formaContribuicao=${formaContribuicao}&&documentoImposto=${documento}&&projetoId=${projeto}`)

        const items = response.data.documentos || [];
        if (items.length > 0) {

          const itemData: ILista[] = items.map((item: ILista) => ({
            dataInserida: FormatDate(item.dataInserida),
            //tipoContribuicao: item.tipoContribuicao,
            documentoImposto: item.documentoImposto,
            linkS3: item.linkS3,
            ano: item.ano,
            fundoNome: item.fundoNome,
            projetoNome: item.projetoNome,
          }));

          setData(itemData);
          setLoading(false);
        } else {
          setData([]);
          enqueueSnackbar('Nenhuma doação encontrada para esta página.', {
            variant: 'info',
          });
        }
      } catch (error) {
        console.error('Erro ao carregar doações:', error);
        setData([]);

      } finally {
        setLoading(false);
      }
    } else if (projeto !== undefined && documento === undefined && ano !== undefined ){
      try {
        const response = await api.get(`api/ContribuicoesDarf/ListagemPerfil?perfilId=${idPerfil}&&formaContribuicao=${formaContribuicao}&&ano=${ano}&&projetoId=${projeto}`)

        const items = response.data.documentos || [];
        if (items.length > 0) {

          const itemData: ILista[] = items.map((item: ILista) => ({
            dataInserida: FormatDate(item.dataInserida),
            //tipoContribuicao: item.tipoContribuicao,
            documentoImposto: item.documentoImposto,
            linkS3: item.linkS3,
            ano: item.ano,
            fundoNome: item.fundoNome,
            projetoNome: item.projetoNome,
          }));

          setData(itemData);
          setLoading(false);
        } else {
          setData([]);
          enqueueSnackbar('Nenhuma doação encontrada para esta página.', {
            variant: 'info',
          });
        }
      } catch (error) {
        console.error('Erro ao carregar doações:', error);
        setData([]);

      } finally {
        setLoading(false);
      }
    } else if (projeto !== undefined && documento === undefined && ano === undefined){
      try {
        const response = await api.get(`api/ContribuicoesDarf/ListagemPerfil?perfilId=${idPerfil}&&formaContribuicao=${formaContribuicao}&&projetoId=${projeto}`)

        const items = response.data.documentos || [];
        if (items.length > 0) {

          const itemData: ILista[] = items.map((item: ILista) => ({
            dataInserida: FormatDate(item.dataInserida),
            //tipoContribuicao: item.tipoContribuicao,
            documentoImposto: item.documentoImposto,
            linkS3: item.linkS3,
            ano: item.ano,
            fundoNome: item.fundoNome,
            projetoNome: item.projetoNome,
          }));

          setData(itemData);
          setLoading(false);
        } else {
          setData([]);
          enqueueSnackbar('Nenhuma doação encontrada para esta página.', {
            variant: 'info',
          });
        }
      } catch (error) {
        console.error('Erro ao carregar doações:', error);
        setData([]);
      } finally {
        setLoading(false);
      }
    } else if (projeto === undefined && documento !== undefined && ano !== undefined){
      try {
        const response = await api.get(`api/ContribuicoesDarf/ListagemPerfil?perfilId=${idPerfil}&&formaContribuicao=${formaContribuicao}&&ano=${ano}&&documentoImposto=${documento}`)

        const items = response.data.documentos || [];
        if (items.length > 0) {

          const itemData: ILista[] = items.map((item: ILista) => ({
            dataInserida: FormatDate(item.dataInserida),
            //tipoContribuicao: item.tipoContribuicao,
            documentoImposto: item.documentoImposto,
            linkS3: item.linkS3,
            ano: item.ano,
            fundoNome: item.fundoNome,
            projetoNome: item.projetoNome,
          }));

          setData(itemData);
          setLoading(false);
        } else {
          setData([]);
          enqueueSnackbar('Nenhuma doação encontrada para esta página.', {
            variant: 'info',
          });
        }
      } catch (error) {
        console.error('Erro ao carregar doações:', error);
        setData([]);

      } finally {
        setLoading(false);
      }
    }else if (projeto === undefined && documento !== undefined && ano === undefined){
      try {
        const response = await api.get(`api/ContribuicoesDarf/ListagemPerfil?perfilId=${idPerfil}&&formaContribuicao=${formaContribuicao}&&documentoImposto=${documento}`)

        const items = response.data.documentos || [];
        if (items.length > 0) {

          const itemData: ILista[] = items.map((item: ILista) => ({
            dataInserida: FormatDate(item.dataInserida),
            //tipoContribuicao: item.tipoContribuicao,
            documentoImposto: item.documentoImposto,
            linkS3: item.linkS3,
            ano: item.ano,
            fundoNome: item.fundoNome,
            projetoNome: item.projetoNome,
          }));

          setData(itemData);
          setLoading(false);
        } else {
          setData([]);
          enqueueSnackbar('Nenhuma doação encontrada para esta página.', {
            variant: 'info',
          });
        }
      } catch (error) {
        console.error('Erro ao carregar doações:', error);
        setData([]);

      } finally {
        setLoading(false);
      }
    }else if (projeto === undefined && documento === undefined && ano !== undefined){
      try {
        const response = await api.get(`api/ContribuicoesDarf/ListagemPerfil?perfilId=${idPerfil}&&formaContribuicao=${formaContribuicao}&&ano=${ano}`)

        const items = response.data.documentos || [];
        if (items.length > 0) {

          const itemData: ILista[] = items.map((item: ILista) => ({
            dataInserida: FormatDate(item.dataInserida),
            //tipoContribuicao: item.tipoContribuicao,
            documentoImposto: item.documentoImposto,
            linkS3: item.linkS3,
            ano: item.ano,
            fundoNome: item.fundoNome,
            projetoNome: item.projetoNome,
          }));

          setData(itemData);
          setLoading(false);
        } else {
          setData([]);
          enqueueSnackbar('Nenhuma doação encontrada para esta página.', {
            variant: 'info',
          });
        }
      } catch (error) {
        console.error('Erro ao carregar doações:', error);
        setData([]);

      } finally {
        setLoading(false);
      }
    }
  }


  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }

    return e && e.fileList;
  };



  const onFinish = async (values: any) => {
    setLoadingImporte(true);

    const services = new Services();

    const extensionFileOne = values.upload[0].name.slice(
      ((values.upload[0].name.lastIndexOf('.') - 1) >>> 0) + 2,
    );

    // if (
    //   extensionFileOne.length === 0 ||
    //   extensionFileOne.toLowerCase() !== 'ret' ||
    //   extensionFileOne.toLowerCase() !== 'old' ||
    //   extensionFileOne.toLowerCase() !== 'icx'
    // ) {
    //   setLoading(false);
    //   alert(
    //     'Extensão do arquivo inválida, extensões permitidas .ret, .old, .icx',
    //   );
    //   return;
    // }



    let formData = new FormData();
    formData.append('Arquivo', values.upload[0].originFileObj);
    formData.append('DocumentoImposto', values.DocumentoImposto  ? values.DocumentoImposto  : null,);
    formData.append('PerfilId', idPerfil.toString());
    formData.append('TipoContribuicao',formaContribuicao);
    formData.append('DataDocumento', values.DataDocumento  ? values.DataDocumento  : null,);
    formData.append('ProjetoId', values.ProjetoId  ? values.ProjetoId  : null,);
    formData.append('Ano', values.Ano  ? values.Ano  : null,);



    const { error, response } = await services.ImporteDoacao(formData);

    if (error) {
      enqueueSnackbar(`Ocorreu um erro no importe`, {
        title: 'Ocorreu um erro no importe',
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      setLoadingImporte(false);
      return;
     } else {
      enqueueSnackbar(`Importe concluído com sucesso`, {
        title: 'Importe concluído com sucesso',
        variant: 'success',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      setLoadingImporte(false);
      //alert('Importe concluído com sucesso');
      loadData();
    }

    //window.location.reload();
  };



  const filterDocumento = (id: any) => {
    const forma = documentoDoacaoAnual.filter(x => x.id === id);
    if (forma.length > 0) setSearchTerm(forma[0].descricao);
  };

  const filteredData = data.filter((item) =>
    item.documentoImposto.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleOpenFiltro = () => {
    setOpenFiltro(true);
  };
  const handleOpenImporte= () => {
    setOpenImporte(true);
  };

  return (
    <>
      <Grid
        container
        alignItems="center"
        item
        lg={12}
        md={12}
        xs={12}
        style={{ margin: 5 }}
      >

        {/* MODAL */}

        <Modal
          title="Pendências"
          size="grande"
          openModal={openModalPendencia}
          controlModal={(value: boolean) =>
            setOpenModalPendencia(value)
          }
        >
          <ModalPendencia
            idPerfil={idPerfil}

          />
        </Modal>

        {/* butttons */}
        <InvisibleContent visible= {openFiltro === false && openImporte === false}>
          <Grid item  sm={2} xs={2} style={{paddingTop: 7}}>
            <Button
              color="secondary"
              fullWidth
              style={{
                height: 46,
              }}
              onClick={handleOpenFiltro}
            >
              <TuneOutlined style={{ marginRight: 10 }} /> Filtros
            </Button>
          </Grid>

          <Grid item  sm={3} xs={3} style={{paddingTop: 7, paddingLeft: 8, paddingRight: 8}}>
            <Button
              color="secondary"
              fullWidth
              style={{
                height: 46,
              }}
              onClick={handleOpenImporte}
            >
              <FileUploadOutlined style={{ marginRight: 10 }} /> Importar
            </Button>
          </Grid>

                      <InvisibleContent visible={pendenciaDoc === true }>
                      <Grid item  sm={4} xs={4} style={{paddingTop: 7, paddingLeft: 8, paddingRight: 8}}>
                          <p style={{ color: '#B85151' }} onClick={() => setOpenModalPendencia(true)}>
                            <ReportGmailerrorred onClick={() => setOpenModalPendencia(true)} style={{color: '#CC0000', height: 25, width: 25, marginRight: 2, paddingTop: 7}} ></ReportGmailerrorred>
                             Há documentos pendentes
                          </p>
                        </Grid>
                      </InvisibleContent>

        </InvisibleContent>

        {/* FILTROS */}
        <InvisibleContent visible= {openFiltro === true && openImporte === false}>
        <Form  style={{ width: '100%' }} layout={'vertical'} form={formRef}>
          <Grid container item md={12} lg={12} xs={12} >

          <Grid item md={3} lg={3} xs={12} style={{paddingTop: 7, paddingLeft: 8, paddingRight: 8}}>
              <Form.Item
                name={'projeto'}
              >
                <SelectAntd placeholder="Projeto">
                  {projeto.map((item, index) => (
                    <SelectAntd.Option key={item.projetoId} value={item.projetoId}>
                      {item.projetoNome}
                    </SelectAntd.Option>
                  ))}
                </SelectAntd>
              </Form.Item>
            </Grid>
            <Grid item md={3} lg={3} xs={12} style={{paddingTop: 7, paddingLeft: 8, paddingRight: 8}}>
              <Form.Item
                name={'tipoDocumento'}
              >
                <SelectAntd placeholder="Tipo documento">
                  {documentoDoacaoAnual.map((item, index) => (
                    <SelectAntd.Option key={index} value={item.descricao}>
                      {item.descricao}
                    </SelectAntd.Option>
                  ))}
                </SelectAntd>
              </Form.Item>
            </Grid>

            <Grid item md={2} lg={2} xs={12} style={{paddingTop: 7, paddingLeft: 8, paddingRight: 8}}>
              <Form.Item
                name={'ano'}
              >
                <SelectAntd placeholder="Ano">
                  {ano.map((item, index) => (
                    <SelectAntd.Option key={item.id} value={item.descricao}>
                      {item.descricao}
                    </SelectAntd.Option>
                  ))}
                </SelectAntd>
              </Form.Item>
            </Grid>
            <Grid item lg={2} style={{ padding: 5 }}>
                <ButtonComponent
                  color={'secondary'}
                  onClick={() => { loadDataFiltros();
                  }}
                >
                  <SearchOutlined style={{ marginRight: 10 }} /> Buscar
                </ButtonComponent>
              </Grid>

            <Grid item md={1} lg={1} xs={12} style={{paddingTop: 5, paddingLeft: 8, paddingRight: 8}}>
              <Form.Item
                name="button2"
              >
                <Button
                  color="secondary"
                  onClick={() => {
                    formRef.resetFields();
                    setOpenFiltro(false);
                    loadData();
                    loadDocumentosPendentesIR();
                  }}
                >
                  <CloseRounded style={{ margin: 5 }} />
                </Button>
              </Form.Item>
            </Grid>
          </Grid>

          <Grid
            item
            lg={12}
            md={12}
            xs={12}
            style={{ marginTop: 10 }}
          >
            <TableNoPagination
              loading={loading}
              columns={[columnsLabel]}
              FieldsBold={['documentoImposto']}
              data={data}
              keys={[
                'dataInserida',
            'documentoImposto',
            'ano',
            'linkS3',
            'Detalhes'
              ]}

            />
          </Grid>
          </Form>
        </InvisibleContent>

        {/* ------------------- IMPORTE ---------------------- */}
        <InvisibleContent visible= {openImporte === true && openFiltro === false}>
          <Form
            layout="vertical"
            scrollToFirstError={true}
            onFinish={onFinish}
            //onError={() => HandleChangeEtapa(0)
            //requiredMark={false}
            style={{ width: '100%' }}
            form={formRef}
            initialValues={{
            }}
          >

            <Grid container>
            <Grid  item md={2} lg={2} xs={12} style={{ paddingTop: 5}}>
                <Form.Item
                  name="DataDocumento"
                  //label="Tipo documento"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input
                          type="date"
                          placeholder= 'Data do documento'
                          max={DATA}
                        />
                </Form.Item>
              </Grid>

            <Grid  item md={2} lg={2} xs={12} style={{ paddingTop: 5}}>
                <Form.Item
                  name="ProjetoId"
                  //label="Tipo documento"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <SelectAntd  placeholder="Projeto">
                    {projeto.map((item, index) => (
                      <SelectAntd.Option key={item.projetoId} value={item.projetoId}>
                        {item.projetoNome}
                      </SelectAntd.Option>
                    ))}
                  </SelectAntd>
                </Form.Item>
              </Grid>

              <Grid  item md={2} lg={2} xs={12} style={{ paddingTop: 5}}>
                <Form.Item
                  name="DocumentoImposto"
                  //label="Tipo documento"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <SelectAntd  placeholder="Tipo documento">
                    {documentoDoacaoAnual.map((item, index) => (
                      <SelectAntd.Option key={index} value={item.descricao}>
                        {item.descricao}
                      </SelectAntd.Option>
                    ))}
                  </SelectAntd>
                </Form.Item>
              </Grid>



              <Grid  item md={1} lg={1} xs={12} style={{ paddingTop: 5}}>
                <Form.Item
                  name="Ano"
                  //label="Tipo documento"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <SelectAntd   placeholder="Ano">
                    {ano.map((item, index) => (
                      <SelectAntd.Option key={item.id} value={item.id}>
                        {item.descricao}
                      </SelectAntd.Option>
                    ))}
                  </SelectAntd>
                </Form.Item>
              </Grid>

              <Grid item md={3} lg={3} xs={12} style={{paddingLeft: 0, paddingTop:1}}>
                <Form.Item
                  name="upload"
                  //label="Arquivo retorno: "
                  valuePropName="fileList"
                  getValueFromEvent={normFile}
                  extra=""
                  rules={[
                    {
                      required: true,
                      message: 'Selecione o arquivo',
                    },
                  ]}
                >
                  <Upload maxCount={1} beforeUpload={() => false} listType="text">
                    <ButtonComponent color={'secondary'} fullWidth>
                      <FindInPageOutlined style={{ paddingRight: 0 }} /> Selecionar
                      arquivo
                    </ButtonComponent>
                  </Upload>
                </Form.Item>
              </Grid>

              <Grid item md={1} lg={1} xs={12} style={{paddingTop: 1, paddingRight: 50}}>
                <Spin size="large" spinning={loadingImporte} tip={'Loading...'}>
                  <ButtonComponent
                    type="submit"
                    color={'secondary'}
                    //loading={loading}
                    fullWidth
                  >
                    <CheckCircleOutlined style={{ paddingRight: 0 }}/>
                    Importar
                  </ButtonComponent>
                  </Spin>
              </Grid>

              <Grid item md={1} lg={1} xs={12} style={{paddingTop: 0, paddingLeft: 30, paddingRight: 0}}>
                <Form.Item
                  name="button2"
                >
                  <Button
                    color="secondary"
                    onClick={() => {
                      formRef.resetFields();
                      setOpenImporte(false);
                      loadDocumentosPendentesIR()
                    }}
                    style={{ minWidth: 50, paddingRight: 5, paddingLeft: 5 }}
                  >
                    <CloseRounded style={{ margin: 0 }} />
                  </Button>
                </Form.Item>
              </Grid>
            </Grid>
          </Form>


        </InvisibleContent>




        </Grid>








        <InvisibleContent visible={openFiltro === false}>
      <Grid
        item
        sm={12}
        xs={12}
        style={{ marginTop: 10, paddingLeft: 10, paddingRight: 10 }}
      ></Grid>
      <TableNoPagination
          loading={loading}
          columns={[columnsLabel]}
          data={data}
          keys={[
            'dataInserida',
            'documentoImposto',
            'ano',
            'linkS3',
            'Detalhes'
          ]}


        />
       </InvisibleContent>
    </>
  );
};

export default IR;
